import {deepmerge} from "@mui/utils";
import * as modes from "./modes";
import {receipt as defaultReceipt} from "./tokens";
import type {CoreColor, Color, ColorOptions, ColorModes} from "./types";

export function createColor<T extends object = object>(
    colorOptions?: {mode?: ColorModes} & ColorOptions<T>,
) {
    const {mode = "light", ...other} = colorOptions || {};
    const modeColors = (modes as Record<string, CoreColor>)[mode];
    const colors = {
        ...modeColors,
        receipt: defaultReceipt,
    };

    const color: Color<T> = deepmerge(colors, other || {}) as Color<T>;

    return color;
}
